import { DictionariesService } from "@sa/rep-mdm";
import { MapDataSource } from "../models/MapDataSource";

export async function fetchHasDataYear(dictionariesService: DictionariesService, source: MapDataSource): Promise<number> {
  const calendarDict = await dictionariesService.getDictionary({ id: "slides-f-last-calendar-map", parameters: {
    "p_source": source.identifier
  }})
  const items = await calendarDict.getAll();
  const dateId = Number(items[0]?.id || 0);
  return dateId;
};